import { renderV2 } from 'base/wrapped-render-v2';
import { PoMicroFrontend } from 'micro-frontend.react';
import { decodeEscapeSequence } from 'String.util';
import { renameFileSuccess } from './file';
import { handleStackableModalState } from './helper';

export const renderFileComponent = ({
	fileId,
	employeeFile,
	stacked,
	fileNameNoJquery,
}: {
	fileId: string;
	employeeFile: any;
	stacked: boolean;
	fileNameNoJquery: string;
}) => {
	let rootEl = document.getElementById('renameFile');
	if (!rootEl) {
		rootEl = document.createElement('div');
		rootEl.id = 'renameFile';
		document.body.appendChild(rootEl);
	}

	const row = document.querySelector(
		`[data-file_id="${fileId}"], [data-file-id="${fileId}"]`,
	);

	const fileName =
		row?.getAttribute('data-filename') ||
		row?.getAttribute('data-fileName') ||
		fileNameNoJquery ||
		'';
	const currentFileName = decodeEscapeSequence(fileName);

	const root = renderV2({
		children: (
			<PoMicroFrontend
				route="/files/rename-file"
				fileId={fileId}
				fileName={fileName}
				currentFileName={currentFileName}
				employeeFile={employeeFile}
				stacked={stacked}
				fileNameNoJquery={fileNameNoJquery}
				renameFileSuccess={renameFileSuccess}
				onClose={() => {
					handleStackableModalState(stacked, false);
					if (rootEl) {
						rootEl.remove();
						root.unmount();
					}
				}}
			/>
		),
		attachedElement: rootEl,
	});
};
